<div class="flex flex-col w-full h-auto pb-12">
    <div class="flex flex-col items-center pt-10 px-2 gap-8 w-full lg:px-0">
        <div class="text-4xl w-full text-pet-adm-color-1 font-bold w-full text-center">
            Citas Programadas
        </div>
        <!--------------------------------------------------------------------->
        <div class="flex gap-3 w-full flex-wrap-reverse justify-center px-3 md:flex-nowrap md:w-[650px]">
            <div class="relative mb-6 w-full">
                <div class="absolute inset-y-0 start-0 flex items-center ps-3.5 pointer-events-none">
                    <mat-icon class="text-[#7A7A7A]">search</mat-icon>
                </div>
                <input type="text" id="input-group-1" (input)="searchEvt($event)"
                    class="bg-[#F4F5F4] shadow-md shadow-slate-500 h-10 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full ps-10 p-2.5 placeholder-gray-600"
                    placeholder="Buscar cita..." />
            </div>

            <select (change)="orderByDate($event.target.value)" class="w-auto bg-gray-50 h-10 border-2 border-pet-color-text-1 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-pet-color-text-1 block  p-2.5 px-3">
                <option selected value="asc">Fecha Ascendente</option>
                <option value="desc">Fecha Descendente</option>
            </select>
        </div>
        <!--------------------------------------------------------------------->
    </div>
    <!--calendario de citas-->
    <div #divCalendar class="flex h-full w-full overflow-x-auto px-2 relative">
        <!--dias fechas-->
        <div class="flex flex-col gap-2 w-auto" *ngFor="let datec of fechas">
            <div class="text-white text-center  w-full bg-pet-adm-color-4 py-3 px-6">
                {{datec | date: 'EEEE, d \'de\' MMMM \'del\' y'}}
            </div>
            <div class="flex flex-col gap-2 w-full pr-3 pb-3">
                <ng-container *ngFor="let item of consultasByDate[datec]">
                    <app-appointment *ngIf="item.showComponent" [consulta]="item">
                    </app-appointment>
                </ng-container>
            </div>
        </div>
        <div class="hidden w-auto h-auto fixed lg:flex top-[50%] left-3 text-6xl text-pet-color-2">
            <mat-icon inline="true" class="rounded-full p-4 bg-gray-500 bg-opacity-30 hover:bg-opacity-60">keyboard_double_arrow_left</mat-icon>
        </div>
        <div class="hidden w-auto h-auto fixed lg:flex top-[50%] right-3 text-6xl text-pet-color-2">
            <mat-icon inline="true" class="rounded-full p-4 bg-gray-400 text-opacity-30 bg-opacity-30 hover:bg-opacity-60">keyboard_double_arrow_right</mat-icon>
        </div>
    </div>
    
    
    
    
</div>